<template>
  <v-card>
    <v-row no-gutters class="px-5">
      <div class="headline font-weight-bold ml-2">
        <!-- <translate>Language</translate> -->
      </div>
      <v-radio-group v-model="selected" row style="width: 100%">
        <v-radio
          class="col pa-0"
          :class="[column ? 'col-12' : 'col-md-4 col-6']"
          color="success"
          :value="0"
        >
          <template v-slot:label>
            <div class="black--text text-subtitle-2">
              <translate>All Language</translate>
              <span class="gray3--text"> ({{ sum }}) </span>
            </div>
          </template>
        </v-radio>
        <v-radio
          class="col pa-0"
          :class="[column ? 'col-12' : 'col-4']"
          color="success"
          v-for="item in items"
          :key="item.id"
          :value="item.id"
        >
          <template v-slot:label>
            <div class="black--text text-subtitle-2">
              {{ item.name }}
              <span class="gray3--text text-subtitle-2"
                >({{ item.count || 0 }})</span
              >
            </div>
          </template>
        </v-radio>
      </v-radio-group>
    </v-row>
  </v-card>
</template>
<script>
export default {
  props: {
    column: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: 0,
      list: [],
      sum: "0",
    };
  },
  watch: {
    selected: {
      handler(val) {
        this.$emit("change", val);
      },
    },
    items: {
      immediate: true,
      handler(val) {
        let count = 0;
        for (let i in val) {
          if (val[i].count) {
            count += val[i].count;
          }
        }
        this.sum = count + "";
      },
    },
  },
};
</script>